export default function WorkoutIcon({ color = '#0F172A', size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1.75 18H2.75V8H1.75V12.5H0.25V13.5H1.75V18Z" fill={color} />
      <path
        d="M21.25 18H22.25V13.5H23.75V12.5H22.25V8H21.25V18Z"
        fill={color}
      />
      <path
        d="M8.5 13.5H15.5V18.5C15.5 19.0304 15.7107 19.5391 16.0858 19.9142C16.4609 20.2893 16.9696 20.5 17.5 20.5C18.0304 20.5 18.5391 20.2893 18.9142 19.9142C19.2893 19.5391 19.5 19.0304 19.5 18.5V6.5C19.5 5.96957 19.2893 5.46086 18.9142 5.08579C18.5391 4.71071 18.0304 4.5 17.5 4.5C16.9696 4.5 16.4609 4.71071 16.0858 5.08579C15.7107 5.46086 15.5 5.96957 15.5 6.5V12.5H8.5V6.5C8.5 5.96957 8.28929 5.46086 7.91421 5.08579C7.53914 4.71071 7.03043 4.5 6.5 4.5C5.96957 4.5 5.46086 4.71071 5.08579 5.08579C4.71071 5.46086 4.5 5.96957 4.5 6.5V18.5C4.5 19.0304 4.71071 19.5391 5.08579 19.9142C5.46086 20.2893 5.96957 20.5 6.5 20.5C7.03043 20.5 7.53914 20.2893 7.91421 19.9142C8.28929 19.5391 8.5 19.0304 8.5 18.5V13.5Z"
        fill={color}
      />
    </svg>
  )
}
